package org.tlsys.node.api

import org.tlsys.asIterator

fun ScriptAdminService.scriptsIterator() = getScripts().promise.asIterator()
